var React = require('react');
var cx = require('classnames');
var Link = require('react-router').Link;

var MenuItem = require('./MenuItem');
var UserStore = require('../../stores/UserStore');

function getState() {
  return {
    clientId: UserStore.getClientId(),
    hasUser: UserStore.hasData(),
    roles: UserStore.getCurrentRoles() || [],
  };
}

var Menu = React.createClass({
    getInitialState: function () {
        return {
          ...getState(),
          mobileMenuShown: false,
        }
    },
    componentDidMount: function() {
        UserStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        UserStore.removeChangeListener(this._onChange);
    },
    _onChange: function() {
        this.setState(getState());
    },
    _onToggleMenu: function(e) {
        e.preventDefault();

        this.setState({ mobileMenuShown: !this.state.mobileMenuShown });
    },
    render: function () {
      const owner = this.state.roles.indexOf('OWNER') > -1
      const admin = this.state.roles.indexOf('ADMIN') > -1
      const accounting = this.state.roles.indexOf('ACCOUNTING') > -1
      const tech = this.state.roles.indexOf('TECH') > -1
      const techView = this.state.roles.indexOf('TECH_VIEW') > -1
      const partner = this.state.roles.indexOf('PARTNER') > -1

        var items = [];
        // If we add menu items for logged out users, we need to adjust the Portal component's
        // main-content-toggle-left class.
        if (this.state.hasUser) {
            items.push(<MenuItem key="dashboard" route="dashboard" icon="fa-home fa-fw">Dashboard</MenuItem>);

            if (owner || admin || accounting) {
              items.push(<MenuItem key="accounting" route="accounting" icon="fa-file-text-o fa-fw">Accounting</MenuItem>);
              items.push(<MenuItem key="payment" route="payment" icon="fa-usd fa-fw">Payment</MenuItem>);
            }

            if (owner || admin) {
              items.push(<MenuItem key="access" route="access" icon="fa-users fa-fw">Authorised Users</MenuItem>);
              items.push(<MenuItem key="new-service" externalUrl={_SIGNUP_BASE + '/login'} icon="fa-cloud-download fa-fw">New Service</MenuItem>);
            }

            if (owner || admin || tech || techView) {
              items.push(<MenuItem key="services" route="services" icon="fa-cloud fa-fw">Services</MenuItem>);
            }

            if (partner) {
              items.push(<MenuItem key="partner" route="partner" icon="fa fa-briefcase fa-fw">Partner Portal</MenuItem>);
            }

            items.push(<MenuItem key="settings" route="settings" icon="fa-gear fa-fw">Settings</MenuItem>);

            items.push(<MenuItem key="support" route="support" icon="fa-question-circle fa-fw">Support</MenuItem>);
        }

        return <div className={cx("responsive-admin-menu", { 'sidebar-toggle': !items.length })}>
            <div className="responsive-menu" onClick={this._onToggleMenu}>{this.props.name}
                <div className="menuicon"><i className="fa fa-angle-down"></i></div>
            </div>
            <ul id="menu" className={cx({expanded: this.state.mobileMenuShown})}>
                {items}
            </ul>
        </div>;
    }
})
module.exports = Menu;



// WEBPACK FOOTER //
// ./app/components/Layout/Menu.js